import { z } from 'zod';

/**
 * `/minutes/new`: the PV of a meeting (`meetingId`) or of a calendar event (`eventId`) of a space.
 * Only ids travel in the address, never any text of the meeting.
 */
export const NewMinutesSearchSchema = z.object({
  meetingId: z.string().min(1).max(64).optional().catch(undefined),
  eventId: z.string().min(1).max(64).optional().catch(undefined),
  spaceId: z.string().min(1).max(64).optional().catch(undefined),
});
export type NewMinutesSearch = z.infer<typeof NewMinutesSearchSchema>;
